import React from 'react';
import styled from 'styled-components';
import ICellProps from '../ICellProps';


const DataBlock = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    font-size:12px;
    align-items: center;
    padding: 0 10px;
`;

const Readonly: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props: React.HTMLAttributes<HTMLDivElement>) => {
    return <DataBlock>{props.children}</DataBlock>;
}

export default Readonly;